import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const PaymentsModule = lazy(loadModule);

export default PaymentsModule;
